// utils && hooks
import { getProductSelectedByDrugManufacturerId } from 'utils/productComparison/getProductSelectedByDrugManufacturerId';
import { getSubtotalById } from 'utils/productComparison/getSubTotalById';

export const getSubtotalByIdByKellerhoffAndDifarmer = (id, products, EX5937) => {
    const kellerhoffIds = [6, 13, 14, 15, 16, 17, 22, 23];
    const difarmerIds = [42, 242];
    const combinedIds = [...kellerhoffIds, ...difarmerIds];
    const isCombined = combinedIds.includes(id);

    if (isCombined) {
        // Si es Kellerhoff o Difarmer, sumamos todos los subtotales de esos laboratorios
        return combinedIds.reduce((total, currentId) => {
            const subtotal = getProductSelectedByDrugManufacturerId(currentId, products, EX5937)?.reduce(
                (count, item) => count + (item?.amountSelected || 0),
                0,
            );
            return total + (subtotal || 0);
        }, 0);
    } else {
        return getSubtotalById(id, products, EX5937);
    }
};
